import { resolveTenant } from "./resolve";

/**
 * The tenant active for this build. `NEXT_PUBLIC_TENANT_ID` is inlined at build
 * time (see `src/env.mjs`), so this resolves once per build and is safe to
 * import from both server and client components.
 */
export const activeTenant = resolveTenant(
	process.env.NEXT_PUBLIC_TENANT_ID ?? "default"
);
